import filter from "ramda/src/filter";
import map from "ramda/src/map";
import pipe from "ramda/src/pipe";
import sum from "ramda/src/sum";
import {
  castStringPropsToNumbers,
  calculateTotalArea,
  calculateCeilingArea,
  isBathroom,
  calculateTrimArea,
} from "../areas/interiorArea";
import { isInitialized } from "../areas/baseArea";

export const calculateTotalInteriorWallAreaFlow = pipe(
  filter((area) => isInitialized(area) && !isBathroom(area)),
  map(pipe(castStringPropsToNumbers, calculateTotalArea)),
  sum
);

export const calculateTotalCeilingAreaFlow = pipe(
  filter((area) => isInitialized(area) && !isBathroom(area)),
  map(pipe(castStringPropsToNumbers, calculateCeilingArea)),
  sum
);

export const calculateTotalBathroomAreaFlow = pipe(
  filter((area) => isInitialized(area) && isBathroom(area)),
  map(pipe(castStringPropsToNumbers, calculateTotalArea)),
  sum
);

export const calculateTotalTrimAreaFlow = pipe(
  filter((area) => isInitialized(area)),
  map(pipe(castStringPropsToNumbers, calculateTrimArea)),
  sum
);
